import { httpClient } from "./httpClient";

type Payload = {
  requestorPrimaryPhone: string;
  requestorNtLogin: string;
  requestType: "New Access" | "Modify Access" | "Revoke Access";
  requestTypeId: 1 | 2 | 3;
  revokeType: "Resignation/Termination" | "Unnecessary Access" | null;
  effectiveDate: string;
  justification: string;
  attestation: string;
  draftKey: string;
  requests: {
    isAdvance: boolean;
    startDate: string | null;
    accessDetail: string;
    categoryId: number;
    deviceTypeAppId: number;
    deviceTypeId: number;
    environmentId: number;
    role: string;
    roleId: number;
    subCategoryId: number;
    subCategoryName: string;
    systemTypeId: number;
    userEmail: string;
    userId: string;
    userName: string;
    infrastructureDetails?: {
      environmentId: number;
      role: string;
      accessDetails: string;
      subCategoryName: string;
    }[];
    form?: {
      [key: string]: any; // Check types
    };
  }[];
};

type Data = {
  success: boolean;
  referenceNumbers: string[];
  errors: any;
};

export async function postRequest(payload: Payload): Promise<string[]> {
  try {
    // trim attestion
    payload.attestation = payload.attestation?.trim();
    const { data } = await httpClient.post<Data>(`/api/v1/request`, payload);
    if (data.success) {
      return data.referenceNumbers;
    }

    //TODO: create a better error handling
    throw new Error("There was an error");
  } catch (error) {
    throw error;
  }
}
